export const coordenador_imunizacao = {
  nome: 'Coordenador(a) de Imunização',
  id_perfil: 12,
  dashboard: [
    {
      link: '',
      titulo: 'Notificação ao usuário',
      icone: false,
      imagem: '',
      svg: '',
      key: 'modal_atencao_notificacoes',
      type: 'modal',
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
    },
    {
      link: '/saude-bucal',
      titulo: 'Saúde Bucal',
      icone: false,
      imagem: '',
      svg: 'IndicadoresEsb',
      key: 'saude_bucal',
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/imunizacao',
      titulo: 'Imunização',
      icone: false,
      imagem: require('@/assets/icones/imunizacao.png'),
      key: 'imunizacao',
    },
    {
      link: '/oficinas-treinamentos',
      titulo: 'Oficinas Reuniões Treinamentos',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos',
      featured: true,
    },
    {
      link: '/upa',
      titulo: 'UPA',
      icone: 'icofont-hospital',
      key: 'upa',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/gestao-cadastros/cidadao/painel',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
      // openNewTab: true,
      // callback: function (ctx, navigate) {
      //   const parceiro = ctx.$store.state?.infoMunicipio?.parceiro
      //   if (parceiro == null) {
      //     navigate(this.link, this.openNewTab)
      //   } else {
      //     ctx.$toast.error('Não disponível.', '', { position: 'topRight' })
      //   }
      // },
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [
    {
      link: '/imunizacao/importar-vacinas',
      titulo: 'Importar vacinas',
      icone: false,
      imagem: '',
      svg: 'ImportarVacinas',
      key: 'imunizacao_importar_vacinas',
    },
    {
      link: '/imunizacao/vacina-idade-certa',
      titulo: 'Vacina idade certa',
      icone: false,
      imagem: require('@/assets/icones/situacao_vacinal.png'),
      key: 'vacina_idade_certa',
    },
    {
      link: '/imunizacao/campanha-gripe',
      titulo: 'Campanha gripe',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/campanha-gripe.png'),
      key: 'campanha_gripe',
    },
    {
      link: '/imunizacao/divergencias-vacinas',
      titulo: 'Divergências vacinas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/inconsistencias.png'),
      key: 'divergencia_vacinas',
    },
    {
      link: '/imunizacao/dose-imunizante',
      titulo: 'Dose Imunizante',
      icone: 'icofont-injection-syringe',
      key: 'dose_imunizante',
    },
  ],
  vacina_idade_certa: [
    {
      link: '/imunizacao/vacina-idade-certa/faltosos-vacinas-0-15-anos',
      titulo: '0 - 15 anos',
      icone: false,
      imagem: require('@/assets/icones/2anos.png'),
      key: 'faltosos_2_anos',
    },
    {
      link: '/imunizacao/vacina-idade-certa/hpv-quadrivalente',
      titulo: 'HPV quadrivalente',
      icone: false,
      imagem: require('@/assets/icones/hpv.png'),
      key: 'hpv_quadrivalente',
    },
    {
      link: '/imunizacao/vacina-idade-certa/acwy',
      titulo: 'Meningocócica ACWY',
      icone: false,
      imagem: require('@/assets/icones/acwy.png'),
      key: 'meningococica_acwy',
    },
    {
      link: '/imunizacao/vacina-idade-certa/covid19-infantil',
      titulo: 'COVID-19 Infantil',
      icone: false,
      imagem: '',
      svg: 'Covid19Infantil',
      key: 'covid19_infantil',
    },
    {
      link: '/imunizacao/vacina-idade-certa/criancas-dtp-em-atraso',
      titulo: 'DTP',
      icone: false,
      imagem: '',
      svg: 'Dtp',
      key: 'criancas_dtp_em_atraso',
    },
    {
      link: '/imunizacao/vacina-idade-certa/pneumococica-10v',
      titulo: 'Pneumocócica 10V (conjugada)',
      icone: false,
      imagem: '',
      svg: 'Pneumo',
      key: 'pneumococica_10V',
    },
    {
      link: '/imunizacao/vacina-idade-certa/triplice-viral',
      titulo: 'Tríplice viral',
      icone: false,
      imagem: '',
      svg: 'TripleceViral',
      key: 'triplice_viral',
    },
    {
      link: '/imunizacao/vacina-idade-certa/varicela',
      titulo: 'Varicela',
      icone: false,
      imagem: '',
      svg: 'Varicela',
      key: 'varicela',
    },
    {
      link: '/imunizacao/vacina-idade-certa/tetra-viral',
      titulo: 'Tetra viral',
      icone: 'icofont-injection-syringe',
      key: 'tetra_viral',
    },
    {
      link: '/imunizacao/vacina-idade-certa/vacina-dengue',
      titulo: 'Vacina Dengue',
      icone: 'icofont-injection-syringe',
      key: 'vacina_dengue',
    },
  ],
  divergencia_vacinas: [
    {
      link: '/imunizacao/divergencias-vacinas/vacinas-nao-enviadas',
      titulo: 'Vacinas não enviadas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_nao_enviadas.png'),
      key: 'vacinas_nao_enviadas',
    },
    {
      link: '/imunizacao/divergencias-vacinas/d3-antes-6',
      titulo: 'D3 antes 6 meses',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/D3.png'),
      key: 'd3_antes_6_meses',
    },
    {
      link: '/imunizacao/divergencias-vacinas/vacinas-nascimento-divergente',
      titulo: 'Vacinas nascimento divergente',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_nascimento_divergente',
    },
    {
      link: '/imunizacao/divergencias-vacinas/vacinas-sem-cadastro',
      titulo: 'Vacinas sem cadastro',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_sem_cadastro.png'),
      key: 'vacinas_sem_cadastro',
    },
    {
      link: '/imunizacao/divergencias-vacinas/vacinas-antes-nascimento',
      titulo: 'Vacinas antes nascimento',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_antes_nascimento',
    },
  ],
  indicadores_aps: [
    {
      link: '/indicadores-aps/esf-eap',
      titulo: 'eSF / eAP',
      icone: false,
      imagem: '',
      svg: 'eSFeAP',
      key: 'esf_eap',
    },
    {
      link: '/indicadores-aps/emulti',
      titulo: 'eMulti',
      icone: false,
      imagem: '',
      svg: 'eMulti',
      key: 'emulti',
    },
    {
      link: '/indicadores-aps/indicadores-esb',
      titulo: 'eSB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'indicadores_esb',
    },
    {
      link: '/indicadores-aps/resultado-municipal',
      titulo: 'Resultado Indicadores Qualidade',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'resultado_municipal_indicadores_aps',
    },
  ],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  producao: [],
  vinculo_acompanhamento: [],
  bpa_e_ras: [],
  saude_bucal: [
    {
      link: '/indicadores-aps/indicadores-esb',
      titulo: 'Indicadores eSB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'indicadores_esb',
    },
    {
      link: '/saude-bucal/lrpd',
      titulo: 'LRPD',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal_lrpd',
    },
    {
      link: '/saude-bucal/sesb',
      titulo: 'SESB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal_sesb',
    },
  ],
  indicadores_esb: [
    {
      link: '/indicadores-aps/indicadores-esb/primeira-consulta-programada',
      titulo: 'Primeira consulta',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/indicadores-aps/indicadores-esb/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/indicadores-aps/indicadores-esb/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/indicadores-aps/indicadores-esb/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/indicadores-aps/indicadores-esb/procedimentos-odonto-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/indicadores-aps/indicadores-esb/tratamentos-restauradores-atramautico',
      titulo: 'Tratamento Atraumático',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/indicadores-aps/indicadores-esb/saude-bucal-gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'ConsultasPreNatal',
      key: 'saude_bucal_gestantes',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
  ],
  esf_eap: [
    // {
    //   link: '/busca-ativa/equipe/acs',
    //   titulo: 'Busca Ativa',
    //   icone: 'icofont-search-user',
    //   key: 'busca_ativa',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/indicadores-aps/esf-eap/mais-acesso-aps',
      titulo: 'Mais acesso',
      icone: false,
      imagem: '',
      svg: 'MaisAcessoAps',
      key: 'mais_acesso_aps',
    },

    // {
    //   link: '/indicador-citologico/equipe/acs',
    //   titulo: 'Exames Citopatológico',
    //   icone: 'icofont-stretcher',
    //   key: 'citopatologico',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    // {
    //   link: '/indicador-imunizacao/equipe/acs',
    //   titulo: 'Desenvolvimento infantil',
    //   icone: 'icofont-baby',
    //   key: 'vacinas_polio_penta',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/indicadores-aps/esf-eap/desenvolvimento-infantil',
      titulo: 'Desenvolvimento infantil',
      icone: false,
      imagem: '',
      svg: 'DesenvolvimentoInfantil',
      key: 'desenvolvimento_infantil',
    },
    {
      link: '/indicadores-aps/esf-eap/gestantes-puerperas',
      titulo: 'Gestantes puérperas',
      icone: false,
      imagem: '',
      svg: 'GestantesPuerperas',
      key: 'gestantes_puerperas',
    },
    // {
    //   link: '/pre-natal',
    //   titulo: 'Gestantes e Puérperas',
    //   icone: false,
    //   imagem: require('@/assets/images/pregnant.png'),
    //   key: 'pre_natal',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    // {
    //   link: '/doencas-cronicas',
    //   titulo: 'Doenças crônicas',
    //   icone: 'icofont-drug',
    //   key: 'doencas_cronicas',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/indicadores-aps/esf-eap/pessoa-diabetes',
      titulo: 'Pessoa diabética',
      icone: false,
      imagem: '',
      svg: 'PessoaDiabetes',
      key: 'pessoa_diabetes',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/indicadores-aps/esf-eap/pessoa-hipertensao',
      titulo: 'Pessoa hipertensa',
      icone: false,
      imagem: '',
      svg: 'PessoaHipertensao',
      key: 'pessoa_hipertensao',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/indicadores-aps/esf-eap/pessoa-idosa',
      titulo: 'Pessoa idosa',
      icone: false,
      imagem: '',
      svg: 'PessoaIdosa',
      key: 'pessoa_idosa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/indicadores-aps/esf-eap/saude-da-mulher',
      titulo: 'Saúde mulher',
      icone: false,
      imagem: '',
      svg: 'SaudeDaMulher',
      key: 'saude_da_mulher',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
  ],
  emulti: [
    {
      link: '/indicadores-aps/emulti/media-atendimentos-por-pessoa',
      titulo: 'Pessoas atendidas',
      icone: false,
      imagem: '',
      svg: 'PessoasAtendidas',
      key: 'media_atendimentos_por_pessoa_emulti',
    },
    {
      link: '/indicadores-aps/emulti/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: false,
      imagem: '',
      svg: 'AcoesInterprofissionais',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
  ],
  oficinas_treinamentos: [
    {
      link: '/oficinas-treinamentos-participante',
      titulo: 'Participante',
      icone: 'icofont-user',
      key: 'oficinas_treinamentos_participante',
    },
    {
      link: '/oficinas-treinamentos-certificados',
      titulo: 'Meus Certificados',
      icone: 'icofont-certificate',
      key: 'oficinas_treinamentos_certificados',
    },
  ],
  upa: [
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'upa_atendimentos_pessoa',
    },
  ],
  administracao_importar_dados: [],
  caps: [],
  bolsa_familia: [],
}
